import React from 'react'
import { Channel as PhoenixChannel } from 'phoenix'

export default React.createContext<PhoenixChannel | undefined>(undefined)
